(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shipping-estimator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shipping-estimator')) {
    customElements.define(
      'shipping-estimator',
      class ShippingEstimator extends HTMLElement {
        connectedCallback() {
          this.countrySelect = this.querySelector('[data-shipping-country]');
          this.destination = this.querySelector('[data-shipping-destination]');
          this.ratesList = this.querySelector('[data-shipping-rates]');
          this.unavailable = this.querySelector('[data-shipping-unavailable]');
          this.summaryDestination = this.querySelector('[data-shipping-summary-destination]');
          this.summaryRate = this.querySelector('[data-shipping-summary-rate]');
          this.labels = {
            standard: this.dataset.labelStandard,
            express: this.dataset.labelExpress,
            free: this.dataset.labelFree,
          };
          this.conditionTemplate = this.dataset.conditionGte;

          try {
            this.profile = JSON.parse(this.querySelector('[data-shipping-profile]').textContent);
          } catch (error) {
            this.profile = null;
          }

          if (!this.profile || !this.countrySelect) return;

          this.countrySelect.value = 'US';
          this.countrySelect.addEventListener('change', () => this.render());
          this.render();
        }

        render() {
          const countryCode = this.countrySelect.value;
          const countryName = this.countrySelect.options[this.countrySelect.selectedIndex].textContent.trim();
          const zoneKey = this.profile.countryToZone[countryCode] || this.profile.restOfWorldZone;
          const zone = this.profile.zones[zoneKey];
          const isExcluded = this.profile.excludedCountries.includes(countryCode);
          const rates = isExcluded || !zone ? [] : zone.rates;

          this.destination.textContent = countryName;
          this.summaryDestination.textContent = countryName;
          this.ratesList.replaceChildren();
          this.unavailable.hidden = rates.length > 0;
          this.summaryRate.textContent = this.summaryText(rates);

          rates.forEach((rate) => {
            const item = document.createElement('li');
            item.className = 'shipping-estimator__rate';

            const name = document.createElement('span');
            name.className = 'shipping-estimator__rate-name';
            name.textContent = this.labels[rate.kind] || this.labels.standard;

            const price = document.createElement('span');
            price.className = 'shipping-estimator__rate-price';
            price.textContent = rate.priceLabel;

            item.append(name, price);

            if (rate.detail) {
              const detail = document.createElement('p');
              detail.className = 'shipping-estimator__rate-detail';
              detail.textContent = rate.detail;
              item.append(detail);
            }

            if (rate.minimumOrder) {
              const condition = document.createElement('p');
              condition.className = 'shipping-estimator__rate-condition';
              condition.textContent = this.conditionTemplate.replace('__AMOUNT__', rate.minimumOrder);
              item.append(condition);
            }

            this.ratesList.append(item);
          });
        }

        summaryText(rates) {
          const primaryRate = rates.find((rate) => rate.kind === 'standard') || rates[0];
          if (!primaryRate) return this.dataset.unavailableSummary;
          const eta = primaryRate.detail?.match(/\b\d+\s*[–-]\s*\d+\s*(?:business\s*)?(?:days|months)\b/i)?.[0];
          return [primaryRate.priceLabel, eta].filter(Boolean).join(' · ');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
